@use '~/theme/theme' as *;
@use '~/theme/typography';

.container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  gap: spacing(1);
}

.combobox {
  display: flex;
  align-items: center;
  height: 100%;
  flex-grow: 1;

  &[data-read-only='true'] {
    color: color(grey-500);
  }

  .input {
    flex: 1 0 0;
    width: auto;
    min-width: 0;
    display: flex;
    padding: 0;
    margin: 0 1px;
    text-indent: spacing(1);
  }
}

.button {
  appearance: none;
  border: none;
  background: none;
  margin: 0;
  cursor: pointer;
  display: flex;
  min-width: 0;
  padding: 0 spacing(1);
  width: 100%;
  height: 100%;
}

.skeleton {
  width: 100%;
  height: 100%;
  margin-right: spacing(1);
  border-radius: 6px;
  z-index: -1;
}

.skeletonSubfield {
  flex: 1 0 0;
  display: flex;
  justify-content: start;
  height: 100%;
  align-items: center;

  @include typography.body2;
  @include typography.regular;
}

.subfield {
  display: flex;
  justify-content: space-between;
  height: 100%;
  align-items: center;
  min-width: 0;
  gap: spacing(0.5);

  @include typography.body2;
  @include typography.regular;
}

.code {
  flex: 1 0 0;
}

.description {
  flex: 2 0 0;
  padding: spacing(1) 0;
}

.label {
  min-width: 0;
  flex: 1 0 0;
  text-align: left;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.chevron {
  flex-shrink: 0;
}

.searchField {
  margin: spacing(2) spacing(1.5);

  input:focus {
    outline: none;
  }
}
